import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { sendEventLog } from '../../utils/newTiaraUtil';
import openWithAppTalk from '../../utils/openWithAppTalk'

export default class MembershipAddFriend extends Component {
  constructor(props) {
    super(props);
    this.handleGoBack = this.handleGoBack.bind(this);
    this.handleAddFriend = this.handleAddFriend.bind(this);
  }

  handleGoBack() {
    sendEventLog('add_friend_cancel');
    openWithAppTalk(this.props.device, 'web/close', 'kakaotalk');
  }

  handleAddFriend() {
    const { fetchMembership, profileId } = this.props;
    sendEventLog('add_friend_confirm');
    fetchMembership(profileId, true);
  }

  render() {
    const { membership } = this.props;
    const profileImageUrl = membership.getIn(['profile', 'profileImage', 'smallUrl']);
    return (
      <div id="kakaoWrap">
        <header id="kakaoHead" className="head_membership">
          <h1 className="screen_out">카카오프렌즈 멤버십</h1>
        </header>
        <hr className="hide" />
        <main id="kakaoContent">
          <article id="mArticle">
            <div className="dimmed_layer" />
            <div className="agree_layer">
              <div className="inner_step1_layer">
                <h2 className="screen_out">카카오프렌즈 멤버십 채널 추가 동의</h2>
                <div className="layer_body">
                  <div className="thumb_brand">
                    <img src={profileImageUrl} className="img_g" alt="" />
                  </div>
                  <em className="emph_agree">
                    카카오프렌즈 멤버십 카드<br />저장을 위해 친구 추가 해주세요.
                  </em>
                  <p className="txt_sub">
                    광고와 마케팅 메시지를<br />카카오톡으로 받아 볼 수 있습니다.
                  </p>
                </div>
                <div className="layer_foot">
                  <button type="button" name="add_friend_cancel" lassName="btn_cancel" onClick={this.handleGoBack}>취소</button>
                  <button type="submit" name="add_friend_confirm" className="btn_confirm" onClick={this.handleAddFriend}>확인</button>
                </div>
              </div>
            </div>
            <button type="button" name="add_friend_close" className="ico_sync btn_close" onClick={this.props.onClose}>닫기</button>
          </article>
        </main>
      </div>
    );
  }
}

MembershipAddFriend.propTypes = {
  device: PropTypes.object.isRequired,
  membership: PropTypes.object.isRequired,
  profileId: PropTypes.string.isRequired,
  fetchMembership: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/MembershipAddFriend/index.js